// Brand is fixed per deployment via NEXT_PUBLIC_BRAND (inlined at build time).
// It selects the color palette in globals.css (data-brand on <html>) and the
// static logo/favicon fallbacks below. Client-specific logos from the API
// (clientData.logo / light_logo) always take precedence over these fallbacks.
export type Brand = "mina" | "green";

// Default is the green client theme (current qa deployments predate the
// brand switch and don't set NEXT_PUBLIC_BRAND). Set NEXT_PUBLIC_BRAND=mina
// for the Al-Mina red theme.
export const BRAND: Brand =
  process.env.NEXT_PUBLIC_BRAND === "mina" ? "mina" : "green";

interface BrandAssets {
  /** Logo shown on light backgrounds / light theme */
  lightLogo: string;
  /** Logo shown on dark backgrounds / dark theme */
  darkLogo: string;
  favicon: string;
}

const ASSETS: Record<Brand, BrandAssets> = {
  mina: {
    // Official red "mina˚" wordmark (from the marketing site) reads well on
    // both light and dark surfaces, so one file serves both slots.
    lightLogo: "/images/mina-logo.svg",
    darkLogo: "/images/mina-logo.svg",
    favicon: "/images/mina-favicon.png",
  },
  green: {
    lightLogo: "/logo-green.svg",
    darkLogo: "/logo-white.svg",
    favicon: "/favicon.svg",
  },
};

export const brandAssets = ASSETS[BRAND];
